import Vue from 'vue'

const env = {
    DEV: 'development',
    STA: 'staging',
    PRO: 'production',
    DEMO: 'demo'
}

const AuthenticationService = {
    SELF: 'SELF',
    OPEN_ID: 'OPEN_ID'
}

export const NodeType = {
    STEP: 'STEP',
    CARD: 'CARD'
}

export const GraphType = {
    FLOW_STANDARD: 'FLOW_STANDARD',
    FLOW_CONTAIN_NODE: 'FLOW_CONTAIN_NODE',
    FLOW_FROM_NODE: 'FLOW_FROM_NODE',
    FLOW_TO_NODE: 'FLOW_TO_NODE'
}

export const NodeContextMenuAction = {
    EDIT: 'EDIT',
    RENAME: 'RENAME',
    DELETE: 'DELETE',
    FLOW_STANDARD: 'FLOW_STANDARD',
    FLOW_CONTAIN_NODE: 'FLOW_CONTAIN_NODE',
    FLOW_FROM_NODE: 'FLOW_FROM_NODE',
    FLOW_TO_NODE: 'FLOW_TO_NODE'
}

export const TreeSortType = {
    NAME_ASC: 'NAME_ASC',
    NAME_DSC: 'NAME_DSC',
    TIME_ASC: 'TIME_ASC',
    TIME_DSC: 'TIME_DSC',
    CUSTOM: 'CUSTOM'
}

export const TreeSortTypeIcon = {
    NAME_ASC: 'sort-alphabetical-ascending',
    NAME_DSC: 'sort-alphabetical-descending',
    TIME_ASC: 'sort-clock-ascending',
    TIME_DSC: 'sort-clock-descending',
    CUSTOM: 'sort'
}

export const CardType = {
    TEXT: 'text',
    GO_TO_STEP: 'go_to_step',
    QUICK_REPLY: 'quick_reply',
    IMAGE: 'image',
    CAROUSEL: 'carousel',
    CONFIG: 'config',
    JSON_API: 'json_api',
    FORM: 'form',
    REQUEST_HUMAN_SUPPORT: 'request_human_support',
    REQUEST_USER_LOCATION: 'request_users_location',
    // TYPING: 'typing',
    EMAIL: 'email',
    GET_SENDER_ATTRIBUTE: 'get_sender_attribute',
    UPDATE_SENDER_ATTRIBUTE: 'update_sender_attribute',
    LUA_SCRIPT: 'lua_script',
    TAG: 'tag',
    ZALO_LIST_TEMPLATE: 'zalo_list_template',
    TICKET: 'ticket',
    SMART_REMINDER: 'smart_reminder',
    SUGGEST: 'suggest',
    RATING: 'rating',
    KB_TRIGGER: 'kb_trigger',
    KB_QUERY: 'kb_query',
    KB_MAPPING: 'kb_mapping',
    KB_CALL: 'kb_call'
}

export const MapCardTypeToData = {
    [CardType.TEXT]: {
        name: 'cardText',
        icon: 'mdi-format-text',
        configKey: null
    },
    [CardType.IMAGE]: {
        name: 'image',
        icon: 'mdi-image',
        configKey: null
    },
    [CardType.CAROUSEL]: {
        name: 'carousel',
        icon: 'mdi-view-carousel',
        configKey: null
    },
    [CardType.FORM]: {
        name: 'form',
        icon: 'mdi-application',
        configKey: null
    },
    [CardType.GO_TO_STEP]: {
        name: 'cardGoToStep',
        icon: 'mdi-login-variant',
        configKey: null
    },
    [CardType.CONFIG]: {
        name: 'cardConfig',
        icon: 'mdi-tab-unselected',
        configKey: null
    },
    [CardType.QUICK_REPLY]: {
        name: 'quickReply',
        icon: 'mdi-reply-all',
        configKey: null
    },
    [CardType.JSON_API]: {
        name: 'jsonAPI',
        icon: 'mdi-code-braces',
        configKey: null
    },
    [CardType.REQUEST_HUMAN_SUPPORT]: {
        name: 'requestHumanSupport',
        icon: 'mdi-head',
        configKey: null
    },
    [CardType.ZALO_LIST_TEMPLATE]: {
        name: 'zaloListTemplate',
        icon: 'mdi-server',
        configKey: 'bot_allow_zalo_list_template'
    },
    [CardType.REQUEST_USER_LOCATION]: {
        name: 'requestUserLocation',
        icon: 'mdi-map-marker-radius',
        configKey: 'bot_allow_request_location'
    },
    // [CardType.TYPING]: {
    //     name: 'typing',
    //     icon: 'mdi-application',
    //     configKey: null
    // },
    [CardType.EMAIL]: {
        name: 'email',
        icon: 'mdi-email-outline',
        configKey: 'bot_allow_using_email_card'
    },
    [CardType.GET_SENDER_ATTRIBUTE]: {
        name: 'getSenderAttribute',
        icon: 'mdi-database-export',
        configKey: 'bot_allow_crm'
    },
    [CardType.UPDATE_SENDER_ATTRIBUTE]: {
        name: 'updateSenderAttribute',
        icon: 'mdi-database-import',
        configKey: 'bot_allow_crm'
    },
    [CardType.LUA_SCRIPT]: {
        name: 'luaScript',
        icon: 'mdi-console',
        configKey: 'bot_allow_lua_script'
    },
    [CardType.TAG]: {
        name: 'tag',
        icon: 'mdi-tag',
        configKey: null
    },
    [CardType.TICKET]: {
        name: 'ticket',
        icon: 'mdi-receipt',
        configKey: null
    },
    [CardType.SMART_REMINDER]: {
        name: 'smartReminder',
        icon: 'mdi-thumbs-up-down',
        configKey: 'bot_allow_using_smart_reminder'
    },
    [CardType.SUGGEST]: {
        name: 'suggestion',
        icon: 'mdi-lightbulb-outline',
        configKey: 'bot_allow_suggest_card'
    },
    [CardType.KB_TRIGGER]: {
        name: 'cardKBTrigger',
        icon: 'mdi-book-open-blank-variant',
        configKey: 'bot_knowledge_base_enable'
    },
    [CardType.RATING]: {
        name: 'ratingAgent',
        icon: 'mdi-thumbs-up-down',
        configKey: null
    }
}

export const OperatorList = [
    {
        text: '=',
        value: '='
    },
    {
        text: '!=',
        value: '!='
    },
    {
        text: '>',
        value: '>'
    },
    {
        text: '>=',
        value: '>='
    },
    {
        text: '<',
        value: '<'
    },
    {
        text: '<=',
        value: '<='
    },
    {
        text: '&map;',
        value: '?='
    },
    {
        text: 'in',
        value: '[|]'
    },
    {
        text: '!_in',
        value: '![|]'
    },
    {
        text: '&sup;',
        value: '[.]'
    },
    {
        text: 'wis',
        value: '[wis]'
    }
]

export const HeaderActionType = {
    HELP: 'HELP',
    ADD_CONDITION: 'ADD_CONDITION',
    COPY: 'COPY',
    ENABLE: 'ENABLE',
    DISABLE: 'DISABLE',
    DELETE: 'DELETE',
    RENAME: 'RENAME',
    EXPAND: 'EXPAND',
    ENABLE_REMINDER: 'ENABLE_REMINDER',
    DISABLE_REMINDER: 'DISABLE_REMINDER',
    OPEN_BUILT_IN_FUNCTION: 'OPEN_BUILT_IN_FUNCTION'
}

export const ButtonType = {
    GO_TO_STEP: 'payload',
    URL: 'url',
    CALL_PHONE: 'phone_call',
    WEBVIEW: 'webview',
    KNOWLEDGE: 'request'
}

export const DefaultAllowButtonType = {
    [ButtonType.GO_TO_STEP]: true,
    [ButtonType.CALL_PHONE]: true,
    [ButtonType.WEBVIEW]: true,
    [ButtonType.URL]: true,
    [ButtonType.KNOWLEDGE]: true
}

export const QuickReplyAllowButtonType = {
    [ButtonType.GO_TO_STEP]: true,
    [ButtonType.CALL_PHONE]: true,
    [ButtonType.WEBVIEW]: false,
    [ButtonType.URL]: false,
    [ButtonType.KNOWLEDGE]: true
}
export const RatingAllowButtonType = {
    [ButtonType.GO_TO_STEP]: false,
    [ButtonType.CALL_PHONE]: false,
    [ButtonType.WEBVIEW]: false,
    [ButtonType.URL]: false
}
export const WebViewType = {
    SITE: 'site',
    CUSTOM: 'custom'
}

export const OPEN_ID_CONFIG_PATH = '/.well-known/openid-configuration/'

export const MODAL_KEYS = {
    DEBUGGER_INSPECT: 'debuggerInspect'
}

const $const = {
    env,
    AuthenticationService,
    OPEN_ID_CONFIG_PATH,
    TOKEN_KEY: 'jwToken',
    LANGUAGE: 'LANGUAGE',
    DATE_FORMAT: 'YYYY-MM-DD',
    dateFormat: 'YYYY-MM-DD',
    timeFormat: 'HH:mm',
    dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    itemPerPage: 15,
    perPageArray: [10, 15, 30, 50, 100],
    sortBy: 'title',
    sortDirection: 'asc',
    sessionStorageKey: {
        provider: 'provider'
    }
}

Vue.prototype.$const = $const

export default $const
